<template>
  <div
    ref="paypalButtonContainer"
    class="w-1/2 flex items-center justify-center"
  ></div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";

export default {
  name: "PaypalButton",
  props: {
    amount: {
      type: Number,
      required: true,
    },
    bookingId: {
      type: String,
    },
  },
  mounted() {
    this.initializePayPalButton();
  },
  methods: {
    async initializePayPalButton() {
      const paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID;
      if (!paypalClientId) {
        console.error("PayPal Client ID is not defined in environment variables");
        return;
      }

      try {
        const paypal = await loadScript({ "client-id": paypalClientId, currency: "USD" });
        if (!paypal || !window.paypal) {
          throw new Error("PayPal SDK failed to load");
        }

        window.paypal
          .Buttons({
            style: {
              layout: "horizontal",
              tagline: false,
              color: "black",
              label: "paypal",
              shape: "rect",
            },
            createOrder: async () => {
              try {
                const params = new URLSearchParams(window.location.search);
                const PCM_NAME = params.get("Code");
                const headers = {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                };
                const response = await window.api.post(
                  "/api/paypal/pay",
                  JSON.stringify({
                    amount: this.amount,
                    currency: "USD",
                    bookingId: this.bookingId,
                    tripName: PCM_NAME,
                  }),
                  headers
                );
                return response.key;
              } catch (error) {
                console.error("Error creating order:", error);
                throw new Error("Failed to create order");
              }
            },
            onApprove: async (data) => {
                const headers = {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                };
                const response = await window.api.post("/api/paypal/capture", JSON.stringify({
                  orderId: data.orderID,
                }), headers);
                if (response.data.status === "COMPLETED") {
                  this.$emit("payment-success", response.data);
                  alert("Payment successful!");
                } else {
                  throw new Error(`Payment capture failed: ${response.data.message}`);
                }
            },
            onError: (err) => {
              console.error("PayPal transaction error:", err);
            },
          })
          .render(this.$refs.paypalButtonContainer);
      } catch (error) {
        console.error("Error loading PayPal SDK:", error);
      }
    },
    cleanHTML(html) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || "";
    },
  },
};
</script>